<template>
<div class="">
  <!-- <form v-on:submit.prevent> -->
    <div
      class="row"
      :class="{ 'mb-0 mx-0 sucheformularergebnis' : type == 'search', 'mb-0' : type == 'home' }"
      :id="type != 'overlay' ? 'sucheformular' : 'ovform'"
    >
      <div
        class="col-12 mb-2"
        :class="{ 'mb-3' : type == 'search' }"
      >
        <h2>{{ messages.headline }}</h2>
      </div>

      <div
        class="col-12 mb-3"
        :class="{ 'col-md-4' : type != 'search' }"
      >
        <div class="position-relative">
          <div class="fakelabel-overlay">{{ messages.inputRight }}</div>

          <a ref="topicsCollapse" :id="'topics_' + type" class="fakedropdown form-control d-flex align-items-center" data-bs-toggle="collapse"
             :href="(type == 'search' ? '#collapseCheckboxenErgebnis' : (type == 'overlay' ? '#collapseCheckboxen' : (type == 'home' ? '#collapseCheckboxenStart' : '')))" role="button" aria-expanded="false"
             :aria-controls="(type == 'search' ? 'collapseCheckboxenErgebnis' : (type == 'overlay' ? 'collapseCheckboxen' : (type == 'home' ? 'collapseCheckboxenStart' : '')))">
            <div>
              <span v-if="selectedTopics.length > 0 && topics && topics.length > 0">{{ selectedTopics.length }}/{{ topics.length }} {{ messages.inputRightChoosen }}</span>
              <span v-else >{{ messages.inputRightPlaceholder }}</span>
            </div>
            <div class="chev-icons ms-auto">
              <div class="chev-down">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" aria-hidden="true">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512" aria-hidden="true"><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg> -->
              </div>
              <div class="chev-up">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                </svg>
              </div>
            </div>

          </a>

          <div class="collapse mb-4"
               :id="(type == 'search' ? 'collapseCheckboxenErgebnis' : (type == 'overlay' ? 'collapseCheckboxen' : (type == 'home' ? 'collapseCheckboxenStart' : '')))"
          >
            <div class="row">
              <div
                v-for="(topic, index) in topics"
                :key="index"
                class="col-12 col-md-6 col-lg-4"
              >
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :value="topic.id" v-model="selectedTopics" :id="'thema_' + index + (type != 'overlay' ? '_start' : '')">
                  <label class="form-check-label checkbox-label d-flex align-items-top" :for="'thema_' + index + (type != 'overlay' ? '_start' : '')">
                    <span>{{ topic.description }}</span>
                    <!-- <span class="ms-auto pe-3">34</span> -->
                  </label>
                </div>
              </div>
              <div class="col-12 text-md-end ps-0">
                <button class="btn btn-link btn-chooseall" @click="chooseAllTopics()" v-if="chooseAll" rel="chooseAll">{{$t("searchlist.chooseAll")}}</button>
                <button class="btn btn-link btn-chooseall" @click="chooseNoTopics()" v-if="chooseNone" rel="chooseNone">{{$t("searchlist.chooseNone")}}</button>
              </div>
            </div> <!-- /row -->

          </div> <!-- /collapse -->
        </div>

      </div> <!-- /col-12 col-md-4 -->

      <div
        class="col-12 mb-3"
        :class="{ 'col-md-4' : type != 'search' }"
      >

      <div class="" :class="(type == 'search') ? 'hsearchsite' : ''">
          <label
            class="fakelabel-overlay"
            :for="type != 'overlay' ? 'sucheOrtStart' : 'sucheOrtOverlay'"
          >{{ messages.inputLeft }}</label>
          <div class="position-relative">
          <input
            @focus="mapRegionToAC"
            @input="searchAutocomplete"
            @blur="chooseAutocompleteData(currentHighlightIndex)"
            type="text"
            class="form-control custom-search-input w-100"
            v-model="selectedRegion"
            :id="type != 'overlay' ? 'sucheOrtStart' : 'sucheOrtOverlay'"
            :placeholder="messages.inputLeftPlaceholder"
            autocomplete="off"
            aria-autocomplete="both"
            @keyup.enter="chooseAutocompleteData(currentHighlightIndex)"
            @keyup.escape="handleCloseAutocomplete"
            @focusout="handleCloseAutocomplete"
            @keyup.up.prevent="highlightNextAutocompleteData(-1)"
            @keyup.down.prevent="highlightNextAutocompleteData(1)"
            aria-controls="autocompleteDropdownList"
            :aria-expanded="hideDropdownList? 'false' : 'true'"
            :aria-activedescendant="highlightAutocompleteId(currentHighlightIndex)"
          >
          <button class="btn btn-suche bg-white custom-search-button me-1" role="button" @click.prevent="flushRegionInput()" v-if="selectedRegion && selectedRegion.length > 3" ref="regionflusButton">
            <img src="../../assets/img/close_x.svg" width="10" height="10" :alt="$t('searchlist.clearIcon')" aria-hidden="true">
            <span class="visually-hidden alert-primary">{{ $t('searchlist.resetInput') }}</span>
          </button>
          </div>
          <!--<ul class="regionlist" ref="autocompletelisteregion" v-if="openAutocomplete && autocompleteData.length == 0" role="listbox">
            <li
              v-for="(region, index) in regions"
              :key="index"
              :data-value="region.id"
              @click="chooseRegionAutocomplete(region)"
              role="option"
              tabindex="0"
            >
              {{ region.name }}
            </li>
          </ul>-->
          <!-- <ul class="regionlist" ref="autocompletelistegeo" v-if="autocompleteData.length > 0" role="listbox">
            <li
              v-for="(geoname, index) in autocompleteData"
              :key="index"
              :data-value="geoname"
              @click="chooseGeonameAutocomplete(geoname)"
              role="option"
            >
              {{ geoname.NAME }}
            </li>
          </ul>-->
          <!-- v-if="!hideDropdownList && autocompleteDataSearch.length > 0" -->
          <ul v-if="!hideDropdownList && autocompleteDataSearch.length > 0" class="autocomplete" id="autocompleteDropdownList" role="listbox">
            <li v-for="(acElement, index) in autocompleteDataSearch"
                  :key="index"
                  @click="chooseAutocompleteData(index)"
                  @mouseover="currentHighlightIndex = index"
                  :class="getListElementCssClass(index)"
                  :aria-selected="getListElementAriaSelected(index)"
                  role="option"
                  :id="highlightAutocompleteId(index)"
                >
                <!--aria-selected="true"-->
              {{acElement.value}}
              <span v-if="acElement.additionalValue" class="additional">
                {{acElement.additionalValue}}
              </span>
            </li>
            <li v-if="autocompleteDataSearch === undefined || autocompleteDataSearch.length === 0"
                @click="handleCloseAutocomplete">
              {{$t("common.noMoreEntries")}}
            </li>
        </ul>

        </div>
      </div>

      <div
        class="col-12 mb-3"
        :class="{ 'col-md-2' : type != 'search' }"
        v-if="type != 'search'"
      >
        <div class="" :class="(type == 'search') ? 'hsearchsite' : ''">
          <label class="position-relative fake-label">
            <input type="checkbox" id="onlineberatung" name="onlineberatung" v-model="withOnlineCounseling">
            <span class="checkbox-fakelabel">&nbsp;{{ $t("searchlist.withonline") }}</span><span class="online-checkbox"></span>
          </label>
        </div>
      </div>

      <div
        class="col-12"
        :class="{ 'col-md-2': type != 'search' }"
      >
        <div v-if="type != 'search'" class="fakelabel d-none d-md-block m-0" aria-hidden="true">&nbsp;</div>
        <button
          @click.prevent="submit()"
          type="submit"
          class="btn btn-primary-custom w-100 mt-12px"
        >{{ messages.searchLabel }}</button>
      </div>

      <div v-if="type == 'search'" class="col-12 mt-5">
        <a href="#" @click.prevent="reset(); submit()" title="">{{ messages.showAllLabel }}</a>
      </div>

    </div> <!-- /row -->
  <!-- </form> -->
  <!-- /suchformular -->

</div>
<!-- Suche ENDE -->
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { LookupValueDto, RegionDto } from "@/generated/openapi/api";
import addressService from '@/services/addressService';
import qs from "qs";
import { GISGeoname } from "@/models/GISGeoname";
import CONFIG from "@/config/config"
import { FilterParams } from "@/models/FilterParams";
import AutocompleteElement from '@/models/autocompleteDropdown/AutocompleteElement';
import _ from 'lodash';

export default defineComponent({
  name: 'Suche',
  props: {
    topics: {
      type: Array as PropType<Array<LookupValueDto>>
    },
    type: {
      type: String,
      default: "home"
    },
    messages: {
      type: Object
    },
    regions: {
      type: Array as PropType<Array<RegionDto>>
    },
    selectedRegionProp: String,
    selectedLong: String,
    selectedLat: String,
    selectedTopicsProp: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  // watch: {
  //   selectedRegion(newVal,oldVal){
  //     if(newVal.length === 0){
  //       console.log('ICH BIN LEER')
  //       this.mapRegionToAC()
  //     }
  //   }
  // },
  data() {
    return {
      config: CONFIG,
      selectedTopics: [] as Array<any>,
      selectedRegion: "",
      selectedCoords: [] as Array<string>, // lat, long
      openAutocomplete: false,
      gisUrlAvailable: false,
      autocompleteData: [] as Array<GISGeoname>,
      autocompleteDataSearch: [] as Array<AutocompleteElement>,
      hideDropdownList: true,
      currentHighlightIndex: 0,
      firstClick: true,
      unique: _.uniqueId("suche-")+"-",
      chooseAll: true,
      chooseNone: false,
      withOnlineCounseling: false,
    }
  },
  // created() {
  //   this.initOnlineCounseling();
  // },
  mounted(){
    // this.initOnlineCounseling();

    if (process.env.VUE_APP_GIS_API_URL) {
      this.gisUrlAvailable = true
    }

    // let persisted = localStorage.getItem('withOnlineCounseling');
    // this.withOnlineCounseling = persisted ? JSON.parse(persisted) : false;

    if(this.selectedRegionProp){
      this.selectedRegion = this.selectedRegionProp
    }

    if(this.selectedTopicsProp){
      this.selectedTopics = this.selectedTopicsProp || [];
      if(this.topics){
        if(this.selectedTopics.length === this.topics.length ){
          this.chooseNone = true;
          this.chooseAll = false;
        }
      }
    }

    if(this.selectedLong && this.selectedLat){
      this.selectedCoords.push(this.selectedLat)
      this.selectedCoords.push(this.selectedLong)
    }
    //console.log('mounted xx',this.regions)
    //this.mapRegionToAC();
  },
  emits: ['submit'],
  methods: {
    // updateOnlineCounseling() {
    //     sessionStorage.setItem('withOnlineCounseling', JSON.stringify(this.withOnlineCounseling));
    // },

    // initOnlineCounseling() {
    //     let persisted = sessionStorage.getItem('withOnlineCounseling');
    //     this.withOnlineCounseling = persisted !== null ? JSON.parse(persisted) : false;
    // },

    mapRegionToAC(){
      if(this.regions){
        // console.log('regions in mount?:',this.regions)
        const acData = this.regions.map( elem => {
          // console.log('xxxxx',elem)
          const dataLine = {} as AutocompleteElement
              dataLine.element = elem
              dataLine.value = elem.name || ''
              dataLine.selectable = true
              return dataLine
        })

        // An empty element
        const allRegionsElem = {
          element: {id: 'ALL', code: '0', name: this.$t('searchlist.allRegions')},
          value: this.$t('searchlist.allRegions'),
          selectable: true
        } as AutocompleteElement

        // Insert element at index 0 (deleting 0 elements)
        acData.splice(0,0, allRegionsElem)

        this.autocompleteDataSearch = acData
        this.hideDropdownList = false
      }
      // console.log('mapregiontoac',this.autocompleteDataSearch)
    },
    getListElementCssClass(index: number) {
      let cssClass = "element-invalid"
      const elem = this.autocompleteDataSearch[index]
      if (elem.selectable === true) {
        cssClass = "element-valid"
      }
      if(this.currentHighlightIndex === index) {
        cssClass += " current"
      }
      if (elem.additionalCssClass !== undefined) {
        cssClass += " " + elem.additionalCssClass
      }
      return cssClass
    },
    getListElementAriaSelected(index: number) {

      if(this.currentHighlightIndex === index) {
        return "true"
      } else {
        return ""
      }
    },
    reset() {
      this.selectedTopics = [];
      this.selectedRegion = "";
      this.selectedCoords = [];
      this.currentHighlightIndex = -1;
      this.autocompleteDataSearch = [];
      this.withOnlineCounseling = false;
    },
    submit() {
      // sessionStorage.setItem('withOnlineCounseling', JSON.stringify(this.withOnlineCounseling));

      if (this.type == "search") {
        const ef = this.$refs.topicsCollapse as any
        if( ef.getAttribute('aria-expanded') === "true" ){
          ef.click()
        }
        if(this.selectedRegion.length === 0 || this.selectedRegion.toLowerCase() === "wien" || this.selectedRegion.toLowerCase() === "vienna" || this.selectedRegion.toLowerCase() === "niederösterreich" || this.selectedRegion.toLowerCase() === "lower_austria" || this.selectedRegion.toLowerCase() === "oberösterreich" || this.selectedRegion.toLowerCase() === "upper_austria" || this.selectedRegion.toLowerCase() === "salzburg" || this.selectedRegion.toLowerCase() === "salzburg" || this.selectedRegion.toLowerCase() === "steiermark" || this.selectedRegion.toLowerCase() === "styria" || this.selectedRegion.toLowerCase() === "burgenland" || this.selectedRegion.toLowerCase() === "burgenland" || this.selectedRegion.toLowerCase() === "kärnten" || this.selectedRegion.toLowerCase() === "carinthia" || this.selectedRegion.toLowerCase() === "tirol" || this.selectedRegion.toLowerCase() === "tyrol" || this.selectedRegion.toLowerCase() === "vorarlberg" || this.selectedRegion.toLowerCase() === "vorarlberg" ){
          this.selectedCoords = [];
        }

        this.hideDropdownList = true

        this.$emit('submit', this.selectedTopics, this.selectedRegion, this.selectedCoords, this.withOnlineCounseling);

      } else {
        // create link to search result page with the correct parameters

        if (this.config && this.config.baseSearchHref) {

          let params: FilterParams = {
            topic: this.selectedTopics,
            region: this.selectedRegion,
            coords: this.selectedCoords
          }

          if (this.withOnlineCounseling) {
            params = {
              topic: this.selectedTopics,
              region: this.selectedRegion,
              coords: this.selectedCoords,
              os: ['Mail', 'Chat', 'Video']
            }
          }

          setTimeout(() => {
            location.href = (this as any).config.baseSearchHref + '#?' + qs.stringify(params, { indices: false });
          }, 300);
        }

      }
    },
    chooseRegionAutocomplete(region: RegionDto) {
      this.selectedRegion = region.name || ""
    },
    chooseGeonameAutocomplete(geoname: GISGeoname) {
      // console.log('GEOOO:',geoname)
      this.selectedRegion = geoname.NAME
      this.selectedCoords = []
      let latTemp = geoname.LAT
      if(latTemp.includes(',')){
        latTemp = latTemp.replace(',','.')
      }

      let longTemp = geoname.LNG
      if(longTemp.includes(',')){
        longTemp = longTemp.replace(',','.')
      }
      this.selectedCoords.push(latTemp)
      this.selectedCoords.push(longTemp)
      this.autocompleteData = []
    },
    handleOpenAutocomplete() {
      if (this.selectedRegion == "") {
        this.openAutocomplete = true
      }
    },
    // handleCloseAutocomplete() { // von controlautocompletedropdown
    //   this.searchString = this.initialSearchString
    //   this.currentHighlightIndex = -1
    //   this.hideDropdownList = true
    //   this.$emit('blur')
    // },
    handleCloseAutocomplete() {
      setTimeout(() => {
        // this.openAutocomplete = false
        this.currentHighlightIndex = -1
        this.hideDropdownList = true
        // this.selectedRegion = ''

        // const nextFocus = this.$refs.regionflusButton as any
        // nextFocus.focus()
      }, 200)
    },
    isGeo(object: unknown): object is GISGeoname {
        return Object.prototype.hasOwnProperty.call(object, "LNG")
            && Object.prototype.hasOwnProperty.call(object, "LAT");
    },
    chooseAutocompleteData(index: number) {
      // console.log('CHOOSE ------- ',index)
      // console.log('blur');
      if (index >= 0 && index < this.autocompleteDataSearch.length) {
        // console.log('if index',index);
        const selectedElement = this.autocompleteDataSearch[index]
        if(selectedElement.selectable === true) {
          // console.log('if selectedelement')
          // console.log('AAAAA:',selectedElement)

          if (this.isGeo(selectedElement.element)) {
              // console.log(`ich bin geo`);
              this.chooseGeonameAutocomplete(selectedElement.element)
              this.handleCloseAutocomplete()
          }else{
            // console.log('no geo -> region')
            this.chooseRegionAutocomplete(selectedElement.element)
            this.handleCloseAutocomplete()
          }
        }
        else{
          // console.log('else selectedelement')
          this.handleCloseAutocomplete()
        }
      } else{
        // console.log('else if index')
        // this.handleCloseAutocomplete() // siehe unten

        // Problem aktuell:
        // on focus wenn leer muss die lsite mit den bundesländern kommen
        // ich gebe eine plz ein und drücke tab oder enter -> es muss ein eintrag von liste sein, da sonst zwar der text übernommen wird aber die region/plz dahinter nicht..
        // wenn ich enter oder tab drücke, wird aber im hintergrund nochmals ein searchcomplete aufgerufen (vom debounce?), d.h. wenn ich zb 2000 eingebe soll der erste eintrag 2000 stockerau aus der autocomplete gewählt werden
        // zusätzlich für screenreader muss der 2. autocompletesearch sowieso abgedreht werden, da sonst ständig nach der auswahl die nächste liste vorgelesen wird.... (vlt für phase1 vernachlässigbar? aber für szenario oben gleich mit...)

        // THIS IS NEEDED FOR INPUT, SO THAT THERE IS AN ELEMENT BEHIND THE TEXT!! sonst zB suche nach 2000 -> regionstext = 2000, aber keine Suche nach 2000 ......... aktuelles Problem: nach auswahl wird nochmals ein searchAutocomplete ausgeführt -> das erste element der neuen Suche wird übernommen nicht das aktuelle -.-

        if(this.autocompleteDataSearch.length > 0 && !this.hideDropdownList){
          const selectedElement = this.autocompleteDataSearch[0]
          if (this.isGeo(selectedElement.element)) {
              // console.log(`ich bin geo`);
              this.chooseGeonameAutocomplete(selectedElement.element)

              // this.currentHighlightIndex = -1
              // this.hideDropdownList = true
              // console.log('1')
              // const nextFocus = this.$refs.regionflusButton as any
              // nextFocus.focus()
              this.handleCloseAutocomplete()
          }else{
            // console.log('no geo -> region')
            this.chooseRegionAutocomplete(selectedElement.element)

            // this.currentHighlightIndex = -1
            // this.hideDropdownList = true
            // console.log('2')
            // const nextFocus = this.$refs.regionflusButton as any
            // nextFocus.focus()
            this.handleCloseAutocomplete()
          }
        }
        // NEEDED ENDE
      }
    },
    highlightAutocompleteId(index: number) {
        if(index > -1){
          return this.unique+index;
        }else {
          return ''
        }
    },
    highlightNextAutocompleteData(increment: number) {
      if (this.autocompleteDataSearch === undefined || this.autocompleteDataSearch.length === 0) {
        this.currentHighlightIndex = -1
        return
      }
      let x = (this.currentHighlightIndex + increment)
      if (x < 0) {
        x = this.autocompleteDataSearch.length - 1
      }else if (x >= this.autocompleteDataSearch.length) {
        x = 0
      }
      this.currentHighlightIndex = x
    },
    searchAutocomplete(val: any) {
        // console.log('HILFE:',this.selectedRegion, this.selectedRegion.length)
        // console.log('starte searchautocomplete ', val)
        if(this.firstClick){
          //reset region on first click
          this.selectedRegion = "";
          this.selectedCoords = [];
          this.currentHighlightIndex = -1;
          this.autocompleteDataSearch = []
          this.firstClick = false;
        }
        this.hideDropdownList = false
        if (this.gisUrlAvailable) {
          if (val instanceof Event) {
            //console.log("TEST Value is: " + (val.currentTarget as HTMLInputElement).value);
            val = (val.target as HTMLInputElement).value;
          }
          //console.log("Target Value is: " + val);
          addressService.getAutocompleteAddress(val).then((resp: Array<GISGeoname>) => {
            this.autocompleteData = resp;
            // console.log('ALERT:',resp.length)
            if (resp.length === 0) {
              this.mapRegionToAC()
            } else {
              // console.log('ALERT length > 0',resp.length, resp)
              this.autocompleteDataSearch = resp.map(elem => {
                const dataLine = {} as AutocompleteElement
                dataLine.element = elem
                dataLine.value = elem.NAME
                dataLine.selectable = true
                return dataLine
              })
            }

          }).catch(() => {
            // console.error(err)
            this.mapRegionToAC()
          })
        }

      // console.log('zzz:',this.autocompleteDataSearch)
    },
    flushRegionInput(){
      this.selectedRegion = ''
      this.selectedCoords = []
      this.openAutocomplete = false;
      this.autocompleteData = []
      this.autocompleteDataSearch = []
      this.currentHighlightIndex = -1;
      this.hideDropdownList = true;
    },
    chooseNoTopics(){
      this.chooseNone = false;
      this.chooseAll = true;
      this.selectedTopics = [];
    },
    chooseAllTopics(){
      this.chooseAll = false
      this.chooseNone = true;
      this.selectedTopics = [];
      if(this.topics){
        this.topics.forEach( (item: any) => {
          this.selectedTopics.push(item.id)
        } )

      }
    }
  },
});
</script>

<style scoped>
/* TODO: Check if Frauen and Familienberatung has the same colors */
ul {
  padding: 0.375rem 0.4rem;
  list-style-type: none !important;
  border-color: #d6d6d6;
  border-style: solid;
  border-width: 0px 1px 1px 1px;
}

ul li {
  cursor: pointer;
  display: block;
  padding: 5px;
}

ul li:hover {
  background: #F2F2F2;
}

li.current {
  background: #F2F2F2 !important;
}

.hsearchsite {
  position: relative;
}

@media screen and (max-width: 767px) {
  .hsearchsite,
  .hsearchsite .regionlist {
    position: initial !important;
  }
}
.hsearchsite .regionlist {
  position: absolute;
  width: 100%;
  background-color: #fff;
  z-index: 40;
}

#collapseCheckboxenErgebnis {
  z-index: 10;
}

.btn-chooseall{
  color: #757575;
}
</style>
